type ZoomSdk = {
  openUrl: (options: { url: string }) => Promise<void>
}

const zoomError = 'Failed to open link in Zoom client, falling back to default behavior'

/**
 * Open an external link in a new tab or browser window.
 * Accounts for environment-specific limitations (e.g. Zoom client).
 * @param {string} url - URL to open
 * @story #7456; User Story 10368: AI widgets: add disclaimer and report functionality
 */
export async function openExternalLink(url: string) {
  if ((window as { zoomSdk?: ZoomSdk }).zoomSdk) {
    // Fallback for Zoom client: cannot open new tabs, open browser window instead
    try {
      await (window as { zoomSdk?: ZoomSdk }).zoomSdk?.openUrl({ url })
    } catch (error) {
      console.warn(zoomError, error)
      window.open(url, '_blank')
    }
  } else {
    window.open(url, '_blank')
  }
}

/**
 * Open an external email (mailto:) link in a new tab or browser window.
 * Accounts for environment-specific limitations (e.g. Zoom client).
 * @param {string} email - email to open
 * @story User Story 10368: AI widgets: add disclaimer and report functionality
 */
export async function openExternalEmailLink(email: string) {
  if ((window as { zoomSdk?: ZoomSdk }).zoomSdk) {
    // Fallback for Zoom client: cannot open new tabs, open browser window instead
    try {
      await (window as { zoomSdk?: ZoomSdk }).zoomSdk?.openUrl({
        url: `${window.origin}/mailto?number=${encodeURIComponent(email)}`,
      })
    } catch (error) {
      console.warn(zoomError, error)
      window.open(`mailto:${email}`, '_blank')
    }
  } else {
    window.open(`mailto:${email}`, '_blank')
  }
}
